import { createAsyncThunk } from '@reduxjs/toolkit';
import { batch } from 'react-redux';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';
import getWarehouse from './getWarehouse';
import getWarehouseExist from '../../general/getWarehouseExist';

const postWarehouse = createAsyncThunk('warehouse/postWarehouse',
  async ({ formData } = {}, { rejectWithValue, dispatch }) => {
    try {
      const data = await authSet(METHOD_POST, '/co/warehouse/', formData);
      batch(() => {
        dispatch(getWarehouse(data));
        dispatch(getWarehouseExist(formData?.part_whs_mpn));
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postWarehouse;
